import { AppConfig } from '../appConfig';

const configLocal: AppConfig = {
  env: 'local',
  url: {
    userWeb: `http://localhost:3040`,
    customerWeb: `http://localhost:3020`,
  },
  apiGateway: {
    region: 'ap-northeast-1',
    endpoint: `http://localhost:3010/local`,
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: {
      staticContents: {
        name: `branq-${process.env.REACT_APP_STAGE}-static-contents`,
        endpoint: `https://d3di0h57m10bbo.cloudfront.net`,
      },
      upload: {
        name: `branq-${process.env.REACT_APP_STAGE}-upload`,
      },
    },
  },
  ses: {
    from: {
      address: 'no-reply@branq.jp',
    },
  },
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_BGLxYKlaN',
    clientId: '6bmb72rgfcuvh8dlearn4d8oaf',
    identityPoolId: 'ap-northeast-1:237420fb-8379-4b62-8fe8-296f97f34016',
  },
};

export default configLocal;
